module.exports = __webpack_public_path__ + "static/img/img-4-6.492007a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-6.png
// module id = cfUu
// module chunks = 0